import { createFeatureSelector } from '@ngrx/store';

export const memberCardBarcodesImagesState = createFeatureSelector<OLO.State, OLO.State.MemberCardBarcodeImage[]>('memberCardBarcodesImages');
